import styled from 'styled-components';
import { useTranslation } from 'react-i18next';
import { SvgIcon, theme } from '@salecycle/ui-component-library';
import { TooltipWithTitle } from 'components/experimental/TooltipWithTitle';
import { WorkflowBadge } from '../../Canvas/components/WorkflowBadge';
import { useSplitTestIdByVariantIdSelector } from '../../../state/SplitTests/selectors/useSplitTestIdByVariantIdSelector';
import { useDefaultVariantSelector } from '../../../state/SplitTests/selectors/useDefaultVariantSelector';

const BadgeContainer = styled.div`
  display: flex;
  align-items: center;
  > div:first-child {
    margin-left: ${({ theme }) => theme.designToken.spacing2};
  }
  > div + div {
    margin-top: -10px;
  }
`;

const TooltipArea = styled.div`
  position: relative;
  color: ${({ theme }) => theme.vars.newColor.darkGS2};
`;

const TooltipIcon = styled.div`
  margin-left: 4px;
  font: ${({ theme }) => theme.designToken.body2Semibold};
`;

interface DefaultVariantProps {
  variantId: string;
}

export const DefaultVariant = ({ variantId }: DefaultVariantProps) => {
  const { t } = useTranslation('campaigns');

  const splitTestId = useSplitTestIdByVariantIdSelector(variantId);
  const defaultVariant = useDefaultVariantSelector(splitTestId);
  const isDefaultVariant = defaultVariant?.messageId === variantId;

  return defaultVariant && isDefaultVariant ? (
    <BadgeContainer aria-label={`variant ${defaultVariant.name} default badge`}>
      <WorkflowBadge variantId={variantId}>
        {t(`onsite.editor.workflow.splitTest.defaultVariant.badgeLable`)}
      </WorkflowBadge>
      <TooltipArea>
        <TooltipWithTitle content={t(`onsite.editor.workflow.splitTest.defaultVariant.description`)}>
          <TooltipIcon>
            <SvgIcon name="circle-question" size="16" color={theme.designToken.primary700} />
          </TooltipIcon>
        </TooltipWithTitle>
      </TooltipArea>
    </BadgeContainer>
  ) : null;
};
